import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationAutomaticOntologyProtocolCreateRequest,
    ConfigurationAutomaticOntologyProtocolResponse
} from '@/modules/configurationModule/detail/automation/protocols/services/configuration-automatic-ontology-protocol/configuration-automatic-ontology-protocol.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationAutomaticOntologyProtocolService {
    async create(laboratoryId: number, request: ConfigurationAutomaticOntologyProtocolCreateRequest): Promise<ConfigurationAutomaticOntologyProtocolResponse> {
        const response = await axios.post<ConfigurationAutomaticOntologyProtocolResponse>(`/configuration/laboratories/${laboratoryId}/automaticProtocolOntologies`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationAutomaticOntologyProtocolResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationAutomaticOntologyProtocolResponse>>(`/configuration/laboratories/${laboratoryId}/automaticProtocolOntologies`, { ...filterModel }, { params })
        return response.data
    }

    async get(laboratoryId: number, automaticProtocolOntologyId: number): Promise<ConfigurationAutomaticOntologyProtocolResponse[]> {
        const response = await axios.get<ConfigurationAutomaticOntologyProtocolResponse[]>(`/configuration/laboratories/${laboratoryId}/automaticProtocolOntologies/${automaticProtocolOntologyId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/automaticProtocolOntologies/batch`, { data: request })
        return response.data
    }
}

export const configurationAutomaticOntologyProtocolService = new ConfigurationAutomaticOntologyProtocolService()
